import * as React from "react";
import {
  Text,
  View,
  StyleSheet,
  Image,
  TouchableOpacity,
  ScrollView,
} from "react-native";

import { useNavigation, useRoute } from "@react-navigation/native";
import GlobalStyles from "../../components/GlobalStyles";
import Colors from "../../utilities/Color.js";
import { removeCard } from "../../redux/actions/CardActions";

export default function CardsRemoveScreen() {
  const navigation = useNavigation();
  const route = useRoute();
  const sparkle = require("../../assets/res/sparkle.png");

  const cardId = route.params.cardId;

  function submitRemoveCard() {
    removeCard(cardId);
    navigation.goBack();
  }

  return (
    <ScrollView style={styles.scrollView}>
      <View style={GlobalStyles.containerNmax}>
        <View style={styles.bodyContainerFull}>
          <View style={styles.boxContainer}>
            <View style={styles.sparklebox}>
              <Image style={styles.sparkle} source={sparkle} />
            </View>
            <Text style={styles.TextStyleHeader}>Remove this Card</Text>
            <Text style={styles.TextStyleBody}>
              You will no longer accrue rewards with Aura partners when using this card.
            </Text>
            <View style={styles.buttonContainer}>
              <TouchableOpacity
                style={styles.SubmitButtonStyleBack}
                activeOpacity={0.5}
                onPress={() => navigation.goBack()}
              >
                <Text style={styles.TextStyle}>CANCEL</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.SubmitButtonStyleContinue}
                activeOpacity={0.5}
                onPress={() => submitRemoveCard()}
              >
                <Text style={styles.TextStyle}>SUBMIT</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
    </ScrollView>
  );
}
const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
    backgroundColor: Colors.MIDBLUE,
  },
  bodyContainerFull: {
    //width: "100%",
    paddingTop: 50,
    paddingLeft: 35,
    paddingRight: 35,
    marginTop: 180,
  },
  boxContainer: {
    alignContent: "center",
    backgroundColor: "#ffffff",
    //width: "85%",
    alignItems: "center",
    justifyContent: "center",
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    borderBottomLeftRadius: 15,
    maxWidth: 800,
    // alignSelf: "center",
    paddingTop: 40,
    paddingBottom: 25,
    paddingLeft: 25,
    paddingRight: 25,
    marginBottom: 50,
  },
  TextStyleHeader: {
    color: "#333333",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 22,
    width: "100%",
    paddingBottom: 15,
    //paddingLeft: 30,
    //paddingRight: 30,
  },
  TextStyleBody: {
    color: "#000000",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 14,
    //paddingLeft: 30,
    //paddingRight: 30,
    paddingBottom: 20,
    paddingTop: 10,
    lineHeight: 22,
  },
  buttonContainer: {
    flexDirection: "row",
    width: "100%",
    marginTop: 20,
    //marginBottom: 30,
    justifyContent: "space-evenly",
  },
  SubmitButtonStyleContinue: {
    borderRadius: 50,
    backgroundColor: Colors.YELLOW,
    height: 50,
    justifyContent: "center",
    height: 52,
    width: 120,
    //marginRight: 35
  },
  SubmitButtonStyleBack: {
    borderRadius: 50,
    borderColor: "black",
    borderWidth: 1,
    backgroundColor: Colors.WHITE,
    height: 50,
    justifyContent: "center",
    height: 52,
    width: 120,
    //marginRight: 35
  },
  TextStyle: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },
  sparkle: {
    width: 30,
    height: 30,
  },
  sparklebox: {
    position: "absolute",
    top: -25,
    right: -25,
  },
});
